const cedSftpDir = {
  type: 'ConnectEd',
  key: 'ced_sftp_dir',
  value: ''
};

export default cedSftpDir;



// WEBPACK FOOTER //
// ./app/models/cedSftpDir.js